import React, { Component } from 'react';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import services from '../../../services';
import $ from 'jquery'
import { auto } from '@patternfly/react-core/dist/esm/helpers/Popper/thirdparty/popper-core';
// export const DropDownCellProduto = props => {
  
var optionsCapacidades = [];
var DropDownCellTipoVasilha = null;

var IdCorrelativas = null;

class DropDownCellCorrelativaProduto extends Component {
  
  handleChange = e => {
    this.props.onChange({
      dataIndex: 0,
      dataItem: this.props.dataItem,
      field: this.props.field,
      syntheticEvent: e.syntheticEvent,
      value: e.target.value
    });

    IdCorrelativas = e;    
   
    $('#id-Correlativa-Capacidade').html(e.value.value);

  }

  static ChangeValueById(id){

    console.log('DropDownCellCorrelativaDropDownCellCorrelativaDropDownCellCorrelativaDropDownCellCorrelativaDropDownCellCorrelativa')
    optionsCapacidades = [];
    (async () => {
      if(id != undefined && id != ""){
        if(id.value.value != undefined){
          var data = {"IDRegistoProduto" : parseInt(id.value.value.split("-")[1])}
        }else{
          var data = {"IDRegistoProduto" : parseInt(id.value.split("-")[1])}
        }
        
        const Correlativa = await services.apiCall.requestApi(
          "/Rotulos/GetCorrelativas",
          data,
          "get"
        );
        if(Correlativa){
          Correlativa.map((Correlativa) => (
          
            optionsCapacidades.push({text: Correlativa.correlativa, value: Correlativa.valor ,idRotulo: Correlativa.idRotulo})
          ));     
        }else{
          optionsCapacidades = [];
        }; 
        if(Correlativa){
            if(Correlativa.length == 0){
              $(".DropdownCellCorrelativa").attr("disabled", true)
              $(".CapacidadesFDO").attr("disabled", false)
            }else{
              $(".DropdownCellCorrelativa").attr("disabled", false)
              $(".CapacidadesFDO").attr("disabled", true)
            }
          }else{
              $(".DropdownCellCorrelativa").attr("disabled", true)
              $(".CapacidadesFDO").attr("disabled", false)
          };    

      }else{
        optionsCapacidades = [];
      }
      

      

    })();

  }

  componentDidMount = () => {

    // myFunction();

  }

  render() {

    const {
      dataItem
    } = this.props;
    const field = this.props.field || '';

    const dataValue = dataItem[field] === null ? '' : dataItem[field];

    return (
      field == "Correlativa_engarrafado" ? 
        <td>
            {dataItem.inEdit ?
            <DropDownList
              popupSettings={{
                width: 'max-content',
              }}
              onChange={this.handleChange}
              value={optionsCapacidades.length > 0 ? optionsCapacidades.find(c => c.value === (dataValue != null ? dataValue.idRotulo != null ? dataValue.idRotulo :dataValue : null)) : dataItem.Correlativa_engarrafado}
              data={optionsCapacidades}
              textField="text"
              id='id-DropDownCellCapacidades'
            />
            : dataValue != null ? dataValue.text.toString() : undefined}
        </td>
        : 
        <td>
        {dataItem.inEdit ?
        <DropDownList
          popupSettings={{
            width: 'max-content',
          }}
          onChange={this.handleChange}
          value={optionsCapacidades.length > 0 ? optionsCapacidades.find(c => c.value === (dataValue != null ? dataValue.idRotulo != null ? dataValue.idRotulo :dataValue : null)) : dataItem.Correlativa_selos}
          data={optionsCapacidades}
          textField="text"
          id='id-DropDownCellCapacidades'
        />
        : dataValue != null ? dataValue.text.toString() : undefined}
    </td>
    );
  }
}

export default DropDownCellCorrelativaProduto;